// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__7UauO","title":"AfterImages45_title__1_ShM","images":"AfterImages45_images__2WV4s"};